module.exports = __webpack_public_path__ + "static/media/benchvote.6031e957.webp";